import { PropTypes } from 'react-desc';
import { noop } from 'lodash';

var props = {
  /** Props to inject to date input wrapper */
  containerProps: PropTypes.object.description('Props to inject to date input wrapper'),

  /**
   * Triggers the onBlur when focus moves out of date input
   */
  onBlur: PropTypes.func.description('Triggers the onBlur when focus moves out of date input'),

  /**
   * Triggers the onFocus when the component gets the focus
   */
  onFocus: PropTypes.func.description('Triggers the onFocus when the component gets the focus'),

  /**
   * Triggers the onKeyDown
   */
  onKeyDown: PropTypes.func.description('Triggers the onKeyDown'),

  /**
   * Allows a function that is triggered once the date input changes
   */
  onChange: PropTypes.func.description('Allows a function that is triggered once the date input changes'),

  /**
   * Triggers when the date is completely set and  only once you have blurred the
   * corresponding input. For example if you are editing the day and the year and month
   * are already set, once you completely set the day it will trigger.
   */
  onDateChange: PropTypes.func.description(' Triggers when the date is completely set and  only once you have blurred the corresponding input. For example if you are editing the day and the year and month are already set, once you completely set the day it will trigger.'),

  /**
   * Triggers the onError once one input date is wrong
   */
  onError: PropTypes.func.description('Triggers the onError once one input date is wrong'),

  /**
   * Default value once the component is initialized MMDDYYYY
   */
  value: PropTypes.string.description('Default value once the component is initialized MMDDYYYY'),

  /**
   * Whether the date input is disabled or not
   */
  disabled: PropTypes.bool.description('Whether the date input is disabled or not'),

  /**
   * tab index
   */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).description('tab index')
};
var defaultProps = {
  onFocus: noop,
  onBlur: noop,
  onChange: noop,
  onDateChange: noop,
  onKeyDown: noop,
  onError: noop,
  value: '',
  disabled: false,
  containerProps: {}
};

export { defaultProps, props };
//# sourceMappingURL=props.js.map
